import React from 'react';
import CSSModules from 'react-css-modules';
import FacebookShare from '../FacebookShare/FacebookShare';
import DonateButton from './DonateButton';
import styles from './PageFooter.scss';
import { PageState } from 'src/redux/modules/page';
import ShareButton from '../ShareModal/ShareButton';

interface Props {
  canPageReceiveDonations: boolean;
  page: PageState;
  donate: () => void;
  isEnrolledInShareButtonModal: boolean;
  handleShareButtonClick: () => void;
  displayShareButtonIcon: boolean;
}

const PageFooter: React.StatelessComponent<Props> = ({
  donate,
  canPageReceiveDonations,
  page,
  isEnrolledInShareButtonModal,
  handleShareButtonClick,
  displayShareButtonIcon,
}) => {
  return (
    <div styleName="fixed-footer">
      <DonateButton
        donate={donate}
        isActive={canPageReceiveDonations}
        name={page.name}
        pageSection="page > sticky footer"
      />
      <div styleName="fixed-share-button">
        {isEnrolledInShareButtonModal ? (
          <ShareButton
            displayShareButtonIcon={displayShareButtonIcon}
            handleShareClick={handleShareButtonClick}
          />
        ) : (
          <FacebookShare
            location="page > share and donate fixed footer"
            buttonText="Share"
            showCounter
          />
        )}
      </div>
    </div>
  );
};

export default CSSModules(PageFooter, styles);



// WEBPACK FOOTER //
// ./src/components/Page/PageFooter.tsx